/**
 * EmailJS credentials.
 * In production, move these to .env and reference via import.meta.env.
 */
export const EJS_PUBLIC_KEY = import.meta.env.VITE_EJS_PUBLIC_KEY || '6jMyOEzVBVSJciy_X'
export const EJS_SERVICE_ID = import.meta.env.VITE_EJS_SERVICE_ID || 'service_nakh8hk'
export const EJS_TEMPLATE   = import.meta.env.VITE_EJS_TEMPLATE   || 'template_3udtpny'
